<template>
<div>
	<el-dialog :visible.sync="showtempwin" title="选择邮件模板" width="500" :append-to-body="true"  :close-on-click-modal="false">
		<el-row>
			<el-col :span="16"><span class="remark">勾选/取消勾选 即可设置模板</span></el-col>
			<el-col :span="8">
				<el-input v-model="modename" @keyup.enter.native="refreshgrid(true)" placeholder="可按模板名称搜索" size="small" class="input-with-select">
					<el-button slot="append" size="mini">搜索</el-button>
				</el-input>
			</el-col>
		</el-row>
		<tableui
			style="width:100%;margin-top:10px;"
			v-loading="loading"
			ref="templist"
			editcell="0"
			:tableData="templist"
			:columns="columns"
			@checkboxchange="setemailtemp"
			gridheight="400"
		></tableui>
	</el-dialog>
</div>
</template>

<script>
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	data() {
		return {
			modename:'',
			loading:false,
			templist:[],
			pageindex:0,
			pagesize:200,
			showtempwin:false,
			columns:[{ field: 'checkbox',type:'checkbox' },{ field: 'modename', title: '模板名称', type: 'text', sortable: false, width: '80' },
			{ field: 'demo', title: '内容示例', type: 'text', sortable: false, width: '350' }],
			mode:'邮件模板',
			sort:'id ',
			msgid:'',
			email_id:''//邮件模板id
		};
	},
	mounted() {
		
	},
	methods: {
		init(param){
			var that=this;
			this.templist=[];
			this.showtempwin=true;
			if(param.id!=undefined)
				that.msgid=param.id;
			if(param.email_id!=undefined)
				that.email_id=param.email_id;
			this.refreshgrid(true);
		},
		GetSearchObj(){
			var searchinfo={
				searchbox:this.modename
			}
			return searchinfo;
		},
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			this.istop=false;
			if (isrefresh) {
				//刷新
				that.pageindex = 0;
				this.istop=true;
				this.selectedall=false;
				this.checkedrow=[];
			} else {
				//加载下一页
				if (that.pagecount - 1 > that.pageindex) {
					that.pageindex = that.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				var paraminfo={
						mode:this.mode,
						tab:'',
						search: this.GetSearchObj(),
						pageindex: this.pageindex,
						pagesize: this.pagesize,
						sort: this.sort,
						iscount:1,
						showcol: '',
					}
				that.loading = true;
				this.$apipost.get
					.GetGridTable({paraminfo:paraminfo})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.templist = that.templist.concat(res.data);
							} else {
								that.templist = res.data;
							}
						}
						that.setgriddefault(that.templist);
						that.pagecount = res.pagecount;
						that.count = res.count;
					});
			}
		},
		//设置列表默认值,加载数据时调用
		setgriddefault(data) {
			var that = this;
			this.$nextTick(() => {
				data.forEach(row => {
					if(row.id!=null){
						if(row.id==that.email_id){
							that.$refs.templist.$children[0].toggleRowSelection([{row:row, selected:true}]);
						}
					}
			  });
		  });
		},
		setemailtemp(e){
			//debugger
			var that=this;
			var isselected=e.selected;
			if(e.selectedall)
			{
				this.$tool.message('请勾选一条记录', 0);
				that.$refs.templist.$children[0].toggleRowSelection([{row:e.row, selected:!isselected}]);
				return false;
			}
			var paraminfo={
				email_id:e.row.id,
				email_name:e.row.modename,
				isselected:isselected,
				msgid:that.msgid
			}
			this.$apipost.post
				.Setemailtemp({paraminfo:paraminfo})
				.then(res => {
					if(res.state=="1"){
						this.$tool.message('设置成功', 1);
						if(isselected.toString()=="true")
							that.$parent.RollbackSet({type:'email_id',id:that.msgid,email_id:e.row.id});
						else
							that.$parent.RollbackSet({type:'email_id',id:that.msgid,email_id:''});
						that.showtempwin=false;
					}
					else{
						this.$tool.message('设置失败', 0);						
						that.$refs.templist.$children[0].toggleRowSelection([{row:e.row, selected:!isselected}]);
					}
			});
		}
	}
}

</script>

<style scoped="scoped">
	 .remark{
	 	color:#2686c7;
	 	font-size:12pt;
	 	font-weight:bold;
	 	padding-left:10px;
	 }
</style>
